<div style="background-color: white; box-shadow: 2px 2px 3px 2px rgb(192, 190, 190); border-radius: 5px; padding: 10px">
  <ng-container
    [ngTemplateOutlet]="contentTemplate"
    [ngTemplateOutletContext]="{
      $implicit: data,
    }"
  >
  </ng-container>
</div>
